import React from 'react';
import { Link } from 'react-router-dom';
import type { MostValuableCompany } from '@/types/company';
import { formatNumber } from '@/utils/format';

interface MostValuableCompanyTableProps {
  tableData: MostValuableCompany[];
}

export const MostValuableCompanyTable: React.FC<MostValuableCompanyTableProps> = ({ tableData }) => {
  // 转换数据格式
  // const transformedData = tableData.map((company, index) => ({
  //   index,
  //   company: {
  //     name: company.name,
  //     image: `${company.name}.png`, // 假设图片名称与公司名称一致
  //     link: company.crunchbaseUrl || ''
  //   },
  //   valuation: `$${(company.valuation / 1000000000).toFixed(2)}B`,
  //   price: `$${company.latestAugmentPrice?.toFixed(2) || 'N/A'}`,
  //   buySell: {
  //     buy: `$${company.highestBid?.toFixed(2) || 'N/A'}`,
  //     sell: `$${company.lowestAsk?.toFixed(2) || 'N/A'}`
  //   }
  // }));

  return (
    <div className="overflow-x-auto rounded-t-md sm:rounded-t-lg md:rounded-t-xl">
      <table className="min-w-full border-collapse border border-gray-800">
        <thead>
          <tr className="text-xs sm:text-sm md:text-base lg:text-lg pt-3 pb-3 overflow-hidden text-ellipsis whitespace-nowrap font-medium text-white">
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800 rounded-tl-md sm:rounded-tl-lg md:rounded-tl-xl">Company</th>
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800">Last Price</th>
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800">Last Valuation</th>
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800 rounded-tr-md sm:rounded-tr-lg md:rounded-tr-xl">
              <div className="flex align-center justify-center">
                <div>Buy</div>
                <div className="px-2">/</div>
                <div>Sell</div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => (
            <tr key={index} className="hover:bg-[#333434]">
              <td className=" px-2 sm:px-4 md:px-6 py-1 sm:py-2 whitespace-nowrap border border-gray-800">
                <div className="flex items-center">
                  <div className="avatar">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 md:w-9 md:h-9 lg:w-10 lg:h-10 rounded-full">
                      <img
                          className="rounded-full object-cover w-full h-full"
                          src={item.logoLink}
                          alt={item.name}
                      />
                    </div>
                  </div>
                  <div className="ml-2 sm:ml-2 md:ml-3">
                    <div className="font-medium text-white text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">
                      <Link to={`/company-detail/${item.id}?name=${item.name}`}
                            className="hover:text-blue-400">
                        {item.name}
                      </Link>
                    </div>
                  </div>
                </div>
              </td>
              <td className=" px-2 sm:px-4 md:px-6 py-1 sm:py-2 whitespace-nowrap border border-gray-800">
                <div className="text-white text-center text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">
                  {formatNumber(item.lastRoundPreferredSharePrice, { prefix: '$', decimals: 1 })}
                </div>
              </td>
              <td className=" px-2 sm:px-4 md:px-6 py-1 sm:py-2 whitespace-nowrap border border-gray-800">
                <div className="text-white text-center text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">
                  {formatNumber(item.valuation, { prefix: '$', compact: true, decimals: 2 })}
                </div>
              </td>
              <td className=" px-2 sm:px-4 md:px-6 py-1 sm:py-2 whitespace-nowrap border border-gray-800">
                <div className="flex flex-col gap-1 items-center">
                  <div className="text-center text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">
                    {item.highestBid || item.lowestAsk ? (
                      <div className="flex items-center">
                        <div>{formatNumber(item.highestBid, { prefix: '$', decimals: 1 })}</div>
                        <div className="px-2">/</div>
                        <div>{formatNumber(item.lowestAsk, { prefix: '$', decimals: 1 })}</div>
                      </div>
                    ) : (
                      '-'
                    )}
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
